

export enum PropertyType {
    MEASURED = "Measured",
    KEYEDIN = "Keyedin",
    CALCULATED = "Calculated",
}

export interface IReportPropertyData {
    alarm1: number,
    alarm2: number,
    customId: number | string
    id: string,
    directionId: string,
    max: number | string,
    mean: number | string
    min: number | string
    name: string,
    ok: number,
    reject: number,
    standardDeviation: number,
    unit: string;
    isExpanded: boolean;
    instrumentId: string;
    propertyType: PropertyType,
    order: number,
}

export default interface IReportProperties {
    calculatedProperties: IReportPropertyData[];
    keyedInProperties: IReportPropertyData[];
    measuredProperties: IReportPropertyData[];
    properties: IReportPropertyData[]
}

export class ReportProperties implements IReportProperties {
    calculatedProperties: IReportPropertyData[];
    keyedInProperties: IReportPropertyData[];
    measuredProperties: IReportPropertyData[]
    properties: IReportPropertyData[]

    constructor(calculatedProperties: IReportPropertyData[],
        keyedinProperties: IReportPropertyData[],
        measuredProperties: IReportPropertyData[]) {
        this.calculatedProperties = calculatedProperties;
        this.keyedInProperties = keyedinProperties;
        this.measuredProperties = measuredProperties;
        this.properties = [];
        if (this.measuredProperties !== undefined && this.measuredProperties !== null && this.measuredProperties.length > 0) {
            this.measuredProperties.map((data, i) => {
                this.properties.push({
                    ...data,
                    isExpanded: i===0? true : false,
                    propertyType: PropertyType.MEASURED
                })
            })
        }
        if (this.keyedInProperties !== undefined && this.keyedInProperties !== null && this.keyedInProperties.length > 0) {
            this.keyedInProperties.map((data, i) => {
                this.properties.push({
                    ...data,
                    isExpanded: i===0? true : false,
                    propertyType: PropertyType.KEYEDIN
                })
            })
        }
        if (this.calculatedProperties !== undefined && this.calculatedProperties !== null && this.calculatedProperties.length > 0) {
            this.calculatedProperties.map((data,i ) => {
                this.properties.push({
                    ...data,
                    isExpanded: i===0? true : false,
                    propertyType: PropertyType.CALCULATED
                })
            })
        }
         this.properties = this.properties.filter((x:any) => x.readings !== null);
         this.properties = this.properties?.sort((a, b) => (a.order - b.order));
    }
}



const defaultReportProperties = new ReportProperties([], [], []);
export { defaultReportProperties };
